import EmptyMessageBody from "static/images/EmptyMessageBody.svg";

export const EmailPreview = ({
  subject,
  body,
}: {
  subject: string;
  body: string;
}) => (
  <div className="t-border t-border-dashed t-border-neutral-10 t-bg-surface t-rounded t-h-[calc(100%-40px)] t-w-full t-overflow-auto t-p-4 t-text-body-sm t-text-text-60">
    <div>Subject:</div>
    <div dangerouslySetInnerHTML={{ __html: subject }}></div>
    <div className="t-mt-6">Body:</div>
    <div dangerouslySetInnerHTML={{ __html: body }} />
  </div>
);

export const EmptyMessagePreview = () => (
  <div className="t-h-[calc(100%-40px)] t-w-full t-flex t-flex-col t-justify-center t-items-center t-gap-3">
    <img src={EmptyMessageBody} alt="EmptyMessageBody" />
    <div className="t-text-body-sm t-text-text-30 t-w-56 t-text-center">
      Select a template & enter the required data to generate preview
    </div>
  </div>
);

export const MessagePreview = ({ body }: { body: string }) => (
  <div
    className="t-border t-border-dashed t-border-neutral-10 t-bg-surface t-rounded t-h-[calc(100%-40px)] t-w-full t-overflow-auto t-p-4 t-text-body-sm t-text-text-60"
    dangerouslySetInnerHTML={{ __html: body }}
  ></div>
);

export const processMessageBody = (
  templateBody: string,
  fieldNames: string[],
  values: Record<string, string>,
  isEmail: boolean,
  addButtonText: boolean,
  buttonKey?: string
): string => {
  let processedBody = fieldNames.reduce(
    (body, fieldName) =>
      body.replaceAll(
        `{{${fieldName}}}`,
        values[fieldName] || `{{${fieldName}}}`
      ),
    templateBody
  );

  if (addButtonText && buttonKey) {
    processedBody += `<br /><br /> WhatsApp Button link: ${values[buttonKey]}`;
  }
  if (!isEmail) {
    processedBody = processedBody
      .replaceAll("\r\n", "<br />") // Replace newlines with <br />
      .replace(/\*(.*?)\*/g, "<b>$1</b>"); // Replace *text* with <b>text</b>
  }

  return processedBody;
};
